import MillworksContent from './MillworksContent.component';

export default MillworksContent;
